import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import { cancelContract } from '~/services-v2/contract-formalization-api/contract-formalization-api'

export default function useContractCancel(projectId: Ref<string>) {
  const queryClient = useQueryClient()

  const mutationFn = async () => {
    return cancelContract(projectId.value)
  }

  return useMutation({
    mutationFn,
    mutationKey: queryKeys.CONTRACT_BIOMETRY.CANCEL_CONTRACT,
    retry: 3,
    retryDelay: 1000,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.HARDWARE.HISTORY(projectId.value) })
    },
  })
}
